import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
          <p className="text-slate-600 dark:text-slate-400">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles.length > 0) {
    const userRoles = user.roles?.map((role) => role.name?.toUpperCase()) || [];
    const hasRequiredRole = requiredRoles.some((role) =>
      userRoles.includes(role.toUpperCase())
    );
    if (!hasRequiredRole) {
      return <Navigate to="/login" replace />;
    }
  }

  return children({ user });
};

export default ProtectedRoute;
